import { axios } from './config';

// 所有流程定义
export function modulesList(params) {
  return axios.get('/pro_definition/getAll', params, true)
}

// 分类
export function typeList(params) {
  return axios.get('/busType/getBusType', params, true)
}

// 流程定义分页
export function technologicalPro(params) {
  return axios.get('/pro_definition/page', params, true)
}

// 启动流程
export function startModel(params) {
  return axios.post("/processinstance/startProcess", params, true)
}

// 删除流程
export function delModel(params) {
  return axios.post('/processinstance/deleteProcessDeployment', params, true)
}

// 代办列表
export function needDeal(params) {
  return axios.get('/task/get_my_task', params, true)
}

// 审核通过/驳回
export function ispass(params) {
  return axios.post('/processinstance/executeTask', params, true)
}

// 转派
export function reassignment(params) {
  return axios.post('/processinstance/taskProxy', params, true)
}

// 我发起的流程列表
export function myProcess(params) {
  return axios.get('/processinstance/sponsorDoPage', params, true)
}